var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from 'styled-components';
export var CleanButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -webkit-font-smoothing: antialiased;\n  appearance: none;\n  background: none;\n  border-radius: 0;\n  border: 0;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 1rem;\n  font-family: inherit;\n  line-height: 1;\n  text-decoration: none;\n  user-select: none;\n\n  &:hover,\n  &:focus,\n  &:active {\n    text-decoration: none;\n    outline: none;\n  }\n"], ["\n  -webkit-font-smoothing: antialiased;\n  appearance: none;\n  background: none;\n  border-radius: 0;\n  border: 0;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 1rem;\n  font-family: inherit;\n  line-height: 1;\n  text-decoration: none;\n  user-select: none;\n\n  &:hover,\n  &:focus,\n  &:active {\n    text-decoration: none;\n    outline: none;\n  }\n"])));
var templateObject_1;